import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/installPrompt";
import App from "@/App";

// Register the service worker globally so push works even when /settings hasn't been opened.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => { /* ignore */ });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
